import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { RecordContextProvider, useGetOne } from 'react-admin';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { CompanyShowDialogSkeleton } from 'shared/widgets/CompanyShowDialog/CompanyShowDialogSkeleton';
import { Company } from 'types/embedded/company';

import { StyledBox } from './CompanyShowDialog.styled';
import { CompanyShowDialogChipFields } from './CompanyShowDialogChipFields';
import { CompanyShowDialogTable } from './CompanyShowDialogTable';

type CompanyShowDialogProps = {
  company?: Partial<Company>;
  onClose: VoidFunction;
} & DialogProps;

export const CompanyShowDialog = ({
  open,
  company,
  onClose,
}: CompanyShowDialogProps): JSX.Element => {
  const { data, isLoading } = useGetOne(
    Resources.Companies,
    { id: company?.['@id'] },
    { enabled: !!company?.['@id'] },
  );

  const translate = useTypedTranslate();

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <StyledBox>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title={translate('app.companies.details')}
          titleSize="smallBold"
        />
        <CardContent sx={{ paddingBottom: '24px !important', paddingTop: '16px !important' }}>
          {!isLoading ? (
            <RecordContextProvider value={data}>
              <CompanyShowDialogChipFields sourceId="originId" />
              <CompanyShowDialogTable onClose={onClose} />
            </RecordContextProvider>
          ) : (
            <CompanyShowDialogSkeleton />
          )}
        </CardContent>
      </StyledBox>
    </Dialog>
  );
};
